const Guests = ({ children, adults, handleSelector }) => {
  return (
    <div
      onClick={() => handleSelector()}
      className="flex flex-row  md:opacity-90 justify-evenly mt-5 mx-5 md:mx-0 md:mt-0 w-[80vw] h-[7vh] md:w-auto md:h-auto  text-[18px]"
    >
      <span className="flex justify-center   md:justify-start  text-zinc-600 bg-white md:bg-transparent mr-[5px] md:mr-0 lg:text-black md:font-semibold lg:font-normal w-full md:w-auto  text-[18px] ">
       <div className="my-auto">
       {adults} Adults
       </div>
      </span>
      <span className="flex justify-center  md:justify-start text-zinc-600  bg-white md:bg-transparent ml-[5px] md:ml-0 lg:text-black md:font-semibold lg:font-normal w-full md:w-auto text-[18px] ">
      <div className="my-auto">
        {children} Children
        </div>
      </span>
    </div>
  );
};

export default Guests;
